module.exports = __webpack_public_path__ + "vennDailyPrivateAssetReturns.b5a0253d70e68e404a2303350e2753e0.svg";